export const roundOdds = (value: number): number => {
  switch (true) {
    case value < 1.01: {
      return round(value, 3);
    }
    case value < 10: {
      return round(value, 2);
    }
    case value < 20: {
      return round(value, 1);
    }
    default: {
      return Math.ceil(value);
    }
  }
};

function round(value: number, places: number): number {
  return +(Math.round(Number(value + 'e+' + places)) + 'e-' + places);
}
